// extracted by mini-css-extract-plugin
export var actionsRow = "_p-a";
export var actionsRowEnd = "_p-b";
export var askRedoBlackBtn = "_p-d";
export var askRedoBlackBtnIcon = "_p-e";
export var exitModalActionBtn = "_p-c";
export var exitModalRoot = "_p-0";
export var followUpInput = "_p-9";
export var modalContentBody = "_p-7";
export var modalHeaderImage = "_p-2";
export var modalImageLabel = "_p-4";
export var modalImageOverlay = "_p-3";
export var modalImageSubheading = "_p-6";
export var modalImageTitle = "_p-5";
export var modalImageWrapper = "_p-1";
export var reasonCard = "_p-f";
export var reasonCardSelected = "_p-g";
export var reasonIcon = "_p-j";
export var reasonIconWrap = "_p-i";
export var reasonIndicator = "_p-l";
export var reasonIndicatorDot = "_p-n";
export var reasonIndicatorSelected = "_p-m";
export var reasonLabel = "_p-h";
export var reasonList = "_p-8";
export var reasonTitle = "_p-k";